import React from 'react';
import PrivateLayout from '../../../layouts/private';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Alert from '@material-ui/lab/Alert';
import PaymentModel from '../../../../models/payment';
import { lzCallApi } from '../../../../services/LzApiService';
import { lzGetFormattedDateTime } from '../../../../services/LzMoment';
import { lzGetFormattedAmount } from '../../../../services/LzUtils';

class PaymentsScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            payments: [],
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        // Make the api call and get the data
        const data = await lzCallApi('subscription/payments');

        // Load data if call was successful
        if (data) {
            this.setState({
                payments: PaymentModel.parseArray(data.payments),
            });
        }
    }

    render() {
        const { payments } = this.state;

        return (
            <PrivateLayout screenTitle="Your Payments">
                <div className="lz-full-bg-wrapper">
                    <Paper elevation={2} style={{ paddingTop: 24, paddingBottom: 24 }}>
                        <Container>

                            {payments.length < 1 ?
                                <Alert color="warning">No records found!</Alert>
                                :
                                <React.Fragment>
                                    <TableContainer>
                                        <Table stickyHeader className="lz-crud-listing-table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left" className="lz-list-head">Charged On</TableCell>
                                                    <TableCell align="right" className="lz-list-head">Amount Charged</TableCell>
                                                    <TableCell align="center" className="lz-list-head">Reference No.</TableCell>
                                                    <TableCell align="center" className="lz-list-head">Plan Details</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {payments.map((payment, dex) =>
                                                    <TableRow hover key={'rec-' + dex}>
                                                        <TableCell align="left">{lzGetFormattedDateTime(payment.charged_at)}</TableCell>
                                                        <TableCell align="right">{lzGetFormattedAmount(payment.amount)}</TableCell>
                                                        <TableCell align="center">{payment.gateway_transaction_ref}</TableCell>
                                                        <TableCell align="center">{payment.subscription?.package_summary}</TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </React.Fragment>
                            }

                        </Container>
                    </Paper>
                </div>
            </PrivateLayout>
        );
    }

}

export default PaymentsScreen;
